
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Alima.ts;
 * Path: ./src/environments/BaseEnvironments/Alima.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 08/09/25, 09:22;
 * Updated at: 08/09/25, 09:22;
 *
 */

import { InterventiAlimaEnv } from '../Modules/InterventiAlima';
import { getModule, addModule } from '../Utility/ModuleUtility';
/*var Environment = () => {
  var env: any = {};

  return env;
};

var FullEnv = () => {
  var env: any = {};
  env = getModule(Environment());
  return env;
};*/
const  RuoliPersona =  [
  {id:'SO', label: 'Responsabile P.A.I.', menuLabel: 'Responsabili P.A.I.', Menu: false},
  {id:'OP', label: 'Operatore', menuLabel: 'Operatori', Menu: false}
]
var Environment = () => {
  var base:any = {
    production: true,
    hasCustomizer: false,
    baseUrl: '/task/list/R/0',
    Modules:{
      "twoFactorAuth": false,
      "Admin": true,
      "Personale": true,
      "Clienti": true,
      "Interventi": true,
      "Prima_Nota": true,
      "Listini": false,
      "Progetti": true,
      "Prodotti": true,
      "Documenti": true,
      "Scadenzario": true,
      "Spedizioni": false,
      "Stampe": true,
      "Task": true,
      "Shared": true,
      "Dashboard": true,
      "Settings": true,
      "Formazione": true,
      "VersioneCarbotti": false,
      "PartiProdotto": false,
      "Parti": false,
      "Rma": true,
      "Ecommerce": false,
      "ScadenzeFiglie": false,
      "Registrazione": false,
      "Ticket": true,
      "Acquisti": false,
      "taskboard": true,
      "Camera": true,
      "Valutazioni":true
    },
    DashboardClass: "dashboard-alima",
    DashboardAddon: [
      {
        url: '/rma/interventi/dashboard',
        filters: [
          { nome:'Inizio:', oggetti: ['inizio'], modificabile:true ,inputType:'date', class: 'col-lg-3', OnChange: 'refresh' },
          { nome:'Fine:', oggetti: ['fine'], modificabile:true ,inputType:'date', class: 'col-lg-3', OnChange: 'refresh' },
          {
            nome: 'Utente',
            source: '/anagrafica/clienti/list',
            responseHasData: true,
            parameter: [
              {nome:"page", value: 1},
              {nome:"size", value: 200},
              {nome:"ruolo", value: 'C'}
            ],
            oggetti: ['cliente'],
            internalOutput: 'clienteObject',
            OutputField: 'cliente',
            OnChange: 'OnClienteChange',
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un Utente',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'statoCivile',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false
            },
            class: 'col-lg-3',
            visibleifProhibited: true
          },
          {
            nome: 'Esecutore',
            source: '/anagrafica/persone/list',
            responseHasData: true,
            parameter: [
              {nome:"page", value: 1},
              {nome:"size", value: 200}
            ],
            internalOutput: 'managerObject',
            oggetti: ['manager'],
            OutputField: 'operatore',
            OnChange: 'OnOperatoreChange',
            modificabile: true,
            inputType: 'singleDropdown',
            disabledif: { hasRoles:['OP','AS','PS'] },
            placeholder: 'Seleziona un Esecutore',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'fullName',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: true
            },
            class: 'col-lg-3',
            allowedCapacity: ['assegnazione-attivita'],
            visibleifProhibited: false
          },
          {
            modificabile: true,
            nome: 'Tipo Intervento',
            oggetti: ['tipo'],
            inputType: 'singleDropdown',
            source: '/settings/get',
            parameter: [
              {nome:"id", value: "tipo_intervento"},
              {nome:"type", value: "tipo_intervento"}
            ],
            internalOutput: 'tipoObject',
            OutputField: 'tipo',
            placeholder: 'Seleziona',
            settings: {
              closeDropDownOnSelection: true,
              idField: 'id',
              textField: 'label',
              allowSearchFilter: true
            },
            titleClass: 'control-label col-form-label',
            class: 'col-lg-3',
            visibleifProhibited: true
          },
          {
            modificabile: true,
            nome: 'Tipo Bene o servizio',
            oggetti: ['accessorio'],
            inputType: 'singleDropdown',
            source: '/prodotti/list',
            responseHasData: true,
            parameter: [
              { nome: 'page', value: 1 },
              { nome: 'size', value: 200 },
              { nome: 'tipo', value: 69 }
            ],
            internalOutput: 'accessoriObject',
            OutputField: 'accessorio',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'prodotto',
              searchPlaceholderText: 'Cerca',
              allowSearchFilter: true,
              allowRemoteDataSearch: false
            },
            titleClass: 'control-label col-form-label',
            class: 'col-lg-3',
            visibleifProhibited: true
          }
          /*{
            nome: 'Nazionalità',
            source: '/anagrafica/clienti/nazionalita',
            oggetti: ['nazionalita'],
            internalOutput: 'nazionalitaObject',
            OutputField: 'nazionalita',
            OnChange: 'nazionalitachange',
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona una nazionalità',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'label',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false
            },
            class: 'col-lg-3',
            visibleifProhibited: true
          },
          {
            nome: 'Sesso',
            source: '/anagrafica/check/list',
            parameter: [
              {nome:"page", value: 1},
              {nome:"size", value: 200},
              {nome:"cat_id", value: 68}
            ],
            responseHasData: true,
            oggetti: ['sesso'],
            internalOutput: 'sessoObject',
            OutputField: 'sesso',
            OnChange: 'sessochange',
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un sesso',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'check',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false
            },
            class: 'col-lg-3',
            visibleifProhibited: true
          },
          {
            nome: 'Titolo di studio',
            source: '/anagrafica/check/list',
            parameter: [
              {nome:"page", value: 1},
              {nome:"size", value: 200},
              {nome:"cat_id", value: 70}
            ],
            responseHasData: true,
            oggetti: ['titoloStudio'],
            internalOutput: 'titoloStudioObject',
            OutputField: 'titoloStudio',
            OnChange: 'titoloStudiochange',
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un titolo di studio',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'check',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false
            },
            class: 'col-lg-3',
            visibleifProhibited: true
          },
          { nome:'Anno di nascita inizio:', oggetti: ['annoNascita'], modificabile:true ,inputType:'number', class: 'col-lg-3', OnChange: 'refresh' },
          { nome:'Anno di nascita fine:', oggetti: ['annoNascitaFine'], modificabile:true ,inputType:'number', class: 'col-lg-3', OnChange: 'refresh' }
        */],

        campi: [
          {
            nome: "Dati della giornata odierna",
            tipo: "Intestazione",
            larghezza: "col-12",
            class: "dashboard-section-title"
          },
        
          { nome: "Totale utenti", tipo: "text", oggetto: "utenti", larghezza: "col-lg-3", class: "bg-info" },
          { nome: "Utenti con interventi", tipo: "text", oggetto: "utenti_attivi", larghezza: "col-lg-3", class: "bg-info" },
          { nome: "Totale interventi", tipo: "text", oggetto: "num_int_totale", larghezza: "col-lg-3", class: "bg-info" },
          { nome: "Totale interventi in corso", tipo: "text", oggetto: "num_int_aperti_totale", larghezza: "col-lg-3", class: "bg-info" },
        
          {
            nome: "Dati relativi ai filtri selezionati",
            tipo: "Intestazione",
            larghezza: "col-12",
            class: "dashboard-section-title"
          },
        
          { nome: "Utenti", tipo: "text", oggetto: "utenti_creati", larghezza: "col-lg-3", class: "bg-warning" },
          { nome: "Interventi Nuovi Utenti", tipo: "text", oggetto: "num_int_creati", larghezza: "col-lg-3", class: "bg-warning" },
          { nome: "Interventi", tipo: "text", oggetto: "num_int", larghezza: "col-lg-3", class: "bg-warning" },
          { nome: "Interventi in corso", tipo: "text", oggetto: "num_int_aperti", larghezza: "col-lg-3", class: "bg-warning" }
        
          /*{ nome: "Numero Interventi Giornalieri", tipo: "verticalBar", oggetto: "num_int_giorno", class: 'bg-warning' },
          { nome: "Numero Interventi Giornalieri", tipo: "lineChart", oggetto: "num_int_tipo", class: 'bg-warning', id: 'num-int-tipo',
            linechartOptions: {
              responsive: true,
              lineTension: 0,
              scales: {
                x: { grid: { display: false } },
                y: { grid: { display: false } }
              }
            }
          },
          { nome: "Numero Interventi Per Tipo", tipo: "pieChart", oggetto: "num_tipo_int", class: 'bg-warning' },
          { nome: "Interventi per sesso", tipo: "pieChart", oggetto: "int_sesso", class: 'bg-warning' },
          { nome: "Interventi per titolo di studio", tipo: "pieChart", oggetto: "int_titolo", class: 'bg-warning' },
          { nome: "Interventi per nazionalita", tipo: "pieChart", oggetto: "int_nazionalita", class: 'bg-warning' },
          { nome: "Beneficiari(e) per sesso", tipo: "pieChart", oggetto: "utenti_sesso", class: 'bg-warning' },
          { nome: "Beneficiari(e) per titolo di studio", tipo: "pieChart", oggetto: "utenti_titolo", class: 'bg-warning' },
          { nome: "Beneficiari(e) per nazionalità", tipo: "pieChart", oggetto: "utenti_nazionalita", class: 'bg-warning' }
        */]
      }
    ],
    TaskAddon: {
      checkList : true,

      ListTableHeaderField:[
        {nome: "N.", oggetti: ["id"]},
        {nome: "Titolo", oggetti: ["nome"]},
        {nome: "Operatore", oggetti: ['managerObject'], type: "object", field:['fullName'], prohibitedRoles: ['U'] },
        {nome: "Tipo Intervento", oggetti: ['tipoObject'], type: "object", field: ['label'] },
        {nome: "Data", oggetti: ['data_inizio_prevista'], inputType: 'datetime-local'},
      ]
    },
    Personale:{
      Corsi: false,
      Attivita: true,//calendario-lista
      File: true,
      RuoliOperativi:true,
      ReadOnlyProfile: true,
      RuoliPersona: RuoliPersona,
    },
    ClientiAddOn: {
      codAdhoc:false,
      enable:false,
      codUtenteLista:true,
      congelamento: false,
      info:true,
      hidepiva:true,
      cf: true,
      codice_univoco:true,//eta
      etaAutomaticaCodiceUnivoco: true,
      questionario: false,
      commerciale: true,
      segnalatore: true,
      tipoSegnalatore:"F",
      segnalatoreInterno: false,
      sedi: false,
      TipoSedePrimaria: false,
      attivita: false,
      geolocalizzazione: false,
      ruolo: true,
      RuoloDefault:{id: "C", label: "Cliente"},
      Modifica: false,
      prodotti: false,
      rma: true,
      accesso: false,
      referenti: true,
      interventi: false,
      note_private:false,
      rating : false,
      ruoliAccesso:false,
      compilazione:false,//data
      luogoNascita: true,
      dataNascita: true,
      statoCivile:true,//codice destinatario
      titoloStudio: true,//residenza
      occupazione: true,//domicilio
      invalidita: false,//check
      legge104: false,//check
      diagnosi: true,//nazionalita
      accompagnamento:false,//check
      pensione: true,//permesso di soggiornon
      tutelare: true,//Operatore Di Riferimento Servizio Pubblico
      medico: true,//e-mail
      telMedico: true,//tel
      terapia:true,//fax,
      CustomCodice:"${iniziali}${progressivo}",
      menuCanReadonly: true,
      fileOnlyMy: ['U'],
      SezioniInfo: [
        {
          sezione: "Anagrafica",
          titleStyle: { 'font-weight': "700", 'padding': '0.8rem', 'background-color': 'whitesmoke' },
          campi: [
            {
              nome: 'Nominativo',
              oggetti: ['nominativo'],
              modificabile: true,
              inputType: 'text',
              required: true,
              class: 'col-lg-3',
            },
            { nome: 'Email', oggetti: ['email'], modificabile: true, inputType: 'text',required: true, class: 'col-lg-3' },
            {
              nome: 'Codice Fiscale',
              oggetti: ['cf'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-3',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Età',
              oggetti: ['codice_univoco'],
              modificabile: true,
              inputType: 'text',
              class: "col-lg-3",
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Telefono',
              oggetti: ['telefono'],
              modificabile: true,
              inputType: 'number',
              class: 'col-lg-3'
            },
            {
              nome: 'Indirizzo',
              oggetti: ['indirizzo'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-3',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Cap',
              oggetti: ['cap'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-1',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Provincia',
              oggetti: ['provincia'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-2',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Città',
              oggetti: ['citta'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-3',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            }]},
            {
            sezione: "",
            campi:[
            {
              nome: 'Luogo Nascita',
              oggetti: ['luogoNascita'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-3',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Data Nascita',
              oggetti: ['dataNascita'],
              modificabile: true,
              inputType: 'date',
              class: 'col-lg-3',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Codice Beneficiario',
              oggetti: ['statoCivile'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-3',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Residenza',
              oggetti: ['titoloStudio'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-3',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Nazionalità',
              oggetti: ['diagnosi'],
              modificabile: true,
              inputType: 'text',
              class: 'col-lg-3',
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F') && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Servizio di Provenienza',
              source: '/anagrafica/clienti/list',
              parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 }, { nome: "ruolo", value: 'F' }],
              oggetti: ['id_segnalatore'],
              internalOutput: 'segnalatore',
              responseHasData: true,
              OutputField: 'id_segnalatore',
              OnChange: 'id_segnalatorechange',
              modificabile: true,
              inputType: 'singleDropdown',
              placeholder: 'Seleziona',
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'id',
                textField: 'fullName',
                searchPlaceholderText: "Cerca",
                allowSearchFilter: true,
                allowRemoteDataSearch: false,
              },
              class: 'col-lg-3',
              visibleifProhibited: true,
              hideif: { func: (company) => { return !company['ruoliObject']?.map(r => r.id).includes('F')  && !company['ruoli']?.find(x=>x.toLowerCase()=='f')}}
            },
            {
              nome: 'Note',
              oggetti: ['note'],
              modificabile: true,
              inputType: 'textarea',
              class: 'col-lg-12'
            }
          ]
        }
      ]
    },
    ProdottiAddOn: {
      sottoTitolo: false,
      shortDescription: false,
      classeEnergetica: false,
      tags: false,
      video: false,
      dettaglio: false,
      files: true,
      cart: false,
      codice: false,
      codice_produttore: false,
      tipo: true,
      standby: false,
      tipi: false, // tipi di prodotto (1 - 2ante klima)
      cat_image: true,
      lista_prezzo: true,
      TranslatedDesc: false,
      codAdhoc: false,
      DragSort: false,
      cat_Sort: false,

      prodottiFilter: [
        {
          nome: "Cerca",
          oggetti: ['pdv'],
          type: "text",
          filtertype: '69',
          class: 'col-lg-9'
        },
        {
          nome: "Magazzino",
          oggetti: ['magazzino'],
          filtertype: '69',
          source: '/prodotti/magazzini/list/all',
          responseHasData: true,
          parameter: [
            {nome:"page", value: 1},
            {nome:"size", value: 200}
          ],
          internalOutput: 'magazzinoObject',
          OutputField: 'magazzino',
          modificabile: true,
          inputType: 'singleDropdown',
          placeholder: 'Seleziona un Magazzino',
          settings: {
            selectFirst: true,
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'nome',
            searchPlaceholderText: "Cerca",
            allowSearchFilter: true,
            allowRemoteDataSearch: false
          },
          class: 'col-lg-12',
          visibleifProhibited: true
        }
      ],
    ProdottiListHeader:[
      {nome: "Nome", oggetti: ["prodotto"],type: 'text', filtertype: '69' },
      {nome: "Stock", oggetti: ["magazzino"],type: 'text', filtertype: '69' },
      {nome: "Prodotto", oggetti: ["prodotto"],type: 'text', filtertype: '68' },
      {nome: "Quantita da Movimentare", oggetti: ["qta"],type: 'text', filtertype: '69', modificabile: true },
    ],
    AzioniLista:[
      {nome: '', parameterInArray: true,  class:'link font-16 text-orange font-medium mr-2', filtertype: '69', type: 'POST', restRoute: '/prodotti/magazzini/movimentazioni/add',  icon:'fas fa-plus text-orange', successMex: "Carico Effettuato con successo", parameter: [{nome:"prodotto_id", parameter: 'id'}, {nome:'mag_ingresso_id', value: 8}, {nome:'qta', parameter:'qta'}]},
      {nome: '', parameterInArray: true,  class:'link font-16 text-orange font-medium mr-2', filtertype: '69', type: 'POST', restRoute: '/prodotti/magazzini/movimentazioni/add',  icon:'fas fa-minus text-orange', successMex: "Carico Effettuato con successo", parameter: [{nome:"prodotto_id", parameter: 'id'}, {nome:'mag_uscita_id', value: 8}, {nome:'qta', parameter:'qta'}]},
    ],
    SezioniCodiciSconto: [
      {
        sezione:'',
        campi:[
          {
            oggetti: ['prodotto'],
            modificabile: true,
            nome: 'Bene',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },
          {
            oggetti: ['magazzino'],
            modificabile: false,
            nome: 'Stock',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },
          {
            source: "/prodotti/magazzini/movimentazioni/list",
            parameter: [{nome:"page", value: 0}, {nome:"size", value: 200}, {nome: "prodotto_id", parameter: "id" }],
            nome: 'Movimentazioni',
            oggetti: ['movimentazioni'],
            type:"table",
            /* ExternalAddClick: 'movimentazioneAdd',*/
            hideif:{ fieldnotexist:'id'},
            header:[
              {nome: "Magazzino Ingresso", oggetti: ['mag_ingresso'], style:{'margin-left':'10px'},},
              {nome: "Magazzino Uscita", oggetti: ['mag_uscita'], style:{'margin-left':'10px'},},
              {nome: "Data", oggetti: ['created_at'],  inputType: 'datetime-local',style:{'margin-left':'10px'},},
              {nome: "Descrizione", oggetti: ['descrizione'], style:{'margin-left':'10px'},},
              {nome: "Quantita", oggetti: ['qta'], style:{'margin-left':'10px'},},
            ],
            responseHasData: true,
            modificabile: true,
            class: 'col-lg-12',
          }
        ],
      }
    ]
  },
  CalendarAddon: {
    managerScadenza : true,
  },
  PartiAddOn: [false],
  RmaAddOn: {
    pippo: true,
    taskGenerico: true,
    vociDiCosto: false,
    provaAcquisto:true,
    CategoriaProdotto: true,
    TipoAcquisto: false,
    TipoAcquistoSource: "ClientiType",
    Rivenditore:false,
    NumeroDocumento: false,
    DataDocumento: false,
    Ricevuta: false,
    Targhetta: false,
    CircostanzaDifetto: false,
    DescrizioneDifetto: false,
    Difetto: true,
    Telefono: true,
    Garanzia: true,
    EstensioneGaranzia: true,
    Allegati: true,
    Modello: true,
    Matricola: true,
    Brand: true,
    approvato: true,
    hideTaskboard: true,
    sottoTask: true,
    headersScadenza:[
      {nome: "Titolo", oggetti: ["nome"]},
      {nome: "Responsabile", oggetti: ['manager'], type: "object", field:['fullName'] },
      {nome: "Chiuso", oggetti: ['data_fine_effettiva'], inputType: 'datetime-local', type: "boolean"},
    ],
    AzioniScadenza:[
      {nome: '', class:' ',  labelClass:'ml-1 text-orange font-weight-bold', type: 'POST', restRoute: '/rma/segnalazione/prendiincarico', capacita: [], icon:'fas fa-user text-orange', placeholder: 'Prendi in carico', successMex: "Preso in carico", parameter: [{nome:"id", parameter: 'id'}, {nome: 'presaInCarico', value: true}]},
      {nome: '', class:' ',  labelClass:'ml-1 text-danger font-weight-bold', type: 'POST', restRoute: '/rma/segnalazione/delete', preAlert: 'Sei sicuro di voler eliminare questo elemento?', capacita: ['gestione-taskboard'], icon:'fas fa-trash text-danger', placeholder: 'Elimina', successMex: 'Elemento eliminato con successo', parameter: [{nome:"id", parameter: 'id'}]},
    ],
    campiScadenza: [
      {
        modificabile: true,
        nome: 'Responsabile',
        oggetti: ['manager'],
        inputType: 'singleDropdown',
        source: '/anagrafica/persone/list',
        responseHasData: true,
        parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}],
        internalOutput: 'managerObject',
        OnFilter: 'xx',
        OnChange: 'xxy',
        OutputField: 'manager',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'fullName',
          searchPlaceholderText: "inserire almeno 3 caratteri",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
        },
        class: 'col-lg-3',
        visibleifProhibited: true,
      },
      {nome: "Files", type: "Files", url:"/rma/segnalazione/file", modificabile:true, class: 'col-lg-12', OnChange: 'OnFilesChange'},
    ],
    CampiEditTaskboard:[
      {
        sezione: '',
        campi: [
          {nome:'Codice', oggetti: ['id'], modificabile:false ,inputType:'text', class: 'col-lg-3' },
          {
            nome: 'Utente',
            source: '/anagrafica/clienti/list',
            responseHasData: true,
            parameter: [{nome:"page", value: 1}, {nome:"size", value: 1000}, {nome: "ruolo", value: 'C'}],
            oggetti: ['cliente'],
            internalOutput: 'clienteObject',
            OutputField: 'cliente',
            OnChange: 'OnClienteChange',
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un Utente',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'statoCivile',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            nome: 'Esecutore',
            source: '/anagrafica/persone/list',
            responseHasData: true,
            parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}, {nome: "ruolo", value: 'OP'}],
            internalOutput: 'managerObject',
            oggetti: ['manager'],
            OutputField: 'manager',
            OnChange: 'OnOperatoreChange',
            /*OnFilter: 'filtroManager',*/
            modificabile: true,
            inputType: 'singleDropdown',
            disabledif: {hasRoles:['OP','AS','PS']},
            placeholder: 'Seleziona un Operatore',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'fullName',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: true,
            },
            class: 'col-lg-12',
            allowedCapacity: ['assegnazione-attivita'],
            visibleifProhibited: false
          },
          {
            modificabile: true,
            nome: 'Tipo Intervento',
            oggetti: ['tipo'],
            inputType: 'singleDropdown',
            source: '/settings/get',
            parameter: [{nome:"id", value: "tipo_intervento"}, {nome:"type", value: "tipo_intervento"}],
            internalOutput: 'tipoObject',
            OutputField: 'tipo',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'label',
              allowSearchFilter: true,
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            modificabile: true,
            nome: 'InterventoStatus',
            oggetti: ['chiuso'],
            inputType: 'singleDropdown',
            source: [{id:true,label: 'Chiuso'},{id:false,label: 'Non Chiuso'}],
            internalOutput: 'chiusoObject',
            OutputField: 'chiuso',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'label',
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-6',
            visibleifProhibited: true,
          },
          {
            modificabile: true,
            nome: 'Approvazione',
            oggetti: ['approvazione'],
            inputType: 'singleDropdown',
            source: [{id:true,label: 'Approvato'},{id:false,label: 'Non Approvato'}],
            internalOutput: 'approvazioneObject',
            OutputField: 'approvazione',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'label',
            },
            hideif: {hasRoles:['OP','AS']},
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-6',
            visibleifProhibited: true,
          },
          {nome:'Nome Intervento:', oggetti: ['nome'], modificabile:true ,inputType:'text', class: 'col-lg-12' },
          {nome:'Data:', oggetti: ['data_inizio_prevista'], modificabile:true ,inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Fine:', oggetti: ['data_fine_prevista'],  hideif:{fieldnotexist: 'data_fine_prevista'}, modificabile:true ,inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Assegnazione:', oggetti: ['data_assegnazione_tec'],  hideif:{fieldnotexist: 'id'}, disabledif:{fieldexist: 'id'}, modificabile:true ,inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Inizio Effettiva:', oggetti: ['data_inizio_effettiva'], hideif:{fieldnotexist: 'id'}, modificabile: true, inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Fine Effettiva:', oggetti: ['data_fine_effettiva'], hideif:{fieldnotexist: 'id'}, modificabile: true, inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Descrizione Intervento:', oggetti: ['note'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Note Private:', oggetti: ['notePrivate'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {
            modificabile: true,
            nome: 'Aggiungi Beni',
            oggetti: ['addAccessori'],
            inputType: 'singleDropdown',
            source: '/prodotti/list',
            parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}, {nome:"tipo", value: 69}, {nome: "magazzino", parameter: "magazzino" }],
            responseHasData: true,
            internalOutput: 'addAccessoriObject',
            OnChange: "AddAccessorio",
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'prodotto',
              allowSearchFilter: true,
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {nome: 'Beni', oggetti: ['accessoriObject'], type:"table", header:[{nome: "Bene", oggetti: ['prodotto']},{nome: "Quantità", oggetti: ['quantita'], type: 'number', modificabile: true}], modificabile: true, class: 'col-lg-12', azioni:[ {ExternalOnClick: 'OnDelete', icon: 'fa-trash', tooltip:'Elimina', color: 'red'}]},
          {nome: "Files", type: "Files", url:"/rma/rma/file", class: 'col-lg-12', OnChange: 'OnFilesChange', modificabile: true}
        ]
      }
    ],
    headersTaskboard:[
      {nome: "Titolo", oggetti: ["nome"]},
      {nome: "Operatore", oggetti: ['managerObject'], type: "object", field:['fullName'], hideif: {hasRoles:['U']}},
      {nome: "Tipo", oggetti: ['tipoObject'], type: "object", field:['label'] },
      {nome: "Approvazione",oggetti: [''], inputType: 'text', color:[{colore: '#ffd000', fieldexist:'id'}, {colore: '#ff0000', boolFalse:'approvazione'},{colore: '#239d00', boolTrue:'approvazione'}], hideif: {hasRoles:['U']} },
      {nome: "Data", oggetti: ['data_inizio_prevista'], inputType: 'datetime-local'},
    ],
  },
  ProgettiAddon: {
    commerciale: true,
    segnalatore: true,
    categoriaVoceDiCosto: true,
    lavorato: true,

    CampiOfferta: [
      {
        modificabile: true,
        nome: 'Offerta.Responsabile',
        oggetti: ['manager'],
        inputType: 'singleDropdown',
        source: 'managers',
        internalOutput: 'managerObject',
        OnFilter: 'filtroManager',
        OnChange: 'OnManagerChange',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'fullName',
          searchPlaceholderText: "inserire almeno 3 caratteri",
          allowSearchFilter: true,
          allowRemoteDataSearch: true
        },
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'cliente.commerciale',
        oggetti: ['commerciale'],
        inputType: 'singleDropdown',
        source: 'managers',
        internalOutput: 'commerciale',
        OnFilter: 'filtroCommerciale',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'fullName',
          searchPlaceholderText: "inserire almeno 3 caratteri",
          allowSearchFilter: true,
          allowRemoteDataSearch: true
        },
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'cliente.segnalatore',
        oggetti: ['clienti'],
        inputType: 'singleDropdown',
        source: 'clienti',
        internalOutput: 'segnalatore',
        OnFilter: 'filtrosegnalatore',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'nominativo',
          searchPlaceholderText: "inserire almeno 3 caratteri",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
          noDataAvailablePlaceholderText: "Nessun Cliente trovato",
          moreButton: true,
          moreButtonText: "Cerca in AdHoc"
        },
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Colore',
        oggetti: ['colore'],
        inputType: 'color',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-1',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Lavorato',
        oggetti: ['lavorato'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-1',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Oggetto:',
        oggetti: ['oggetto'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Numero Ordine:',
        oggetti: ['codice'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        placeholder: 'Numero Ordine:',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Creazione',
        oggetti: ['data_creazione'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Offerta',
        oggetti: ['data_emissione'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Accettazione',
        oggetti: ['data_accettazione'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Conferma',
        oggetti: ['data_conferma'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Note',
        oggetti: ['note'],
        inputType: 'textarea',
        titleClass: 'control-label col-form-label',
        class: 'col-md-6',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Note Private',
        oggetti: ['note_private'],
        inputType: 'textarea',
        titleClass: 'control-label col-form-label',
        class: 'col-md-6',
        visibleifProhibited: false
      }
    ],

    CampiSottoOfferta: []
  },

  Magazzino: {
    idProdotto: 69,
    CampiLista: [
      {
        nome: 'Magazzini',
        oggetti: ['Lista'],
        type: "table",
        ExternalAddClick: 'OnAdd',
        header: [
          { nome: "Magazzino", oggetti: ['nome'], style: { 'margin-left': '10px' }, hideif: { typeIsNot: ['magazzini'] } },
          { nome: "Nome", oggetti: ['nome'], style: { 'margin-left': '10px' }, hideif: { typeIsNot: ['furgoni'] } },
        ],
        modificabile: true,
        class: 'col-lg-12',
        azioni: [
          { ExternalOnClick: 'OnEdit', icon: 'fa-pencil-alt', tooltip: 'Edit', color: 'blue' },
          { ExternalOnClick: 'OnDelete', icon: 'fa-trash', tooltip: 'Elimina', color: 'red' }
        ]
      }
    ],
    CampiEdit: [
      {
        modificabile: true,
        nome: 'Nome',
        oggetti: ['nome'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-6',
        visibleifProhibited: true,
        hideif: { typeIsNot: ['magazzini'] }
      },
      {
        modificabile: true,
        nome: 'Nome',
        oggetti: ['targa'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true,
        hideif: { typeIsNot: ['furgoni'] }
      },
      {
        source: "/prodotti/magazzini/movimentazioni/list",
        parameter: [{ nome: "page", value: 0 }, { nome: "size", value: 200 }, { nome: "magazzino_id", parameter: "id" }],
        nome: 'Movimentazioni',
        oggetti: ['movimentazioni'],
        type: "table",
        hideif: { fieldnotexist: 'id' },
        header: [
          { nome: "Prodotto", oggetti: ['prodotto'], style: { 'margin-left': '10px' } },
          { nome: "Data", oggetti: ['created_at'], inputType: 'datetime-local', style: { 'margin-left': '10px' } },
          { nome: "Descrizione", oggetti: ['descrizione'], style: { 'margin-left': '10px' } },
          { nome: "Quantita", oggetti: ['qta'], style: { 'margin-left': '10px' } },
        ],
        responseHasData: true,
        modificabile: true,
        class: 'col-lg-12',
        allowedCapacity: ['menu-movimentazioni'],
        visibleifProhibited: false
      }
    ]
  },
  Menu: [
     /*{
        title: "Menu",
        class: "has-arrow",
        label: "Menu",
        extralink: true
      },*/
      {
        module: "taskboard",
        path: "task/list/R/0",
        title: 'menu.taskboard',
        icon: "mdi mdi-calendar",

      },
      {
        module: "Dashboard",
        path: "/dashboard/dynamic",
        title: 'menu.dashboard',
        icon: "mdi mdi-gauge",
        capacita: ["menu-dashboard"]
      },
      {
        module: "Personale",
        path: "/listautenti/personale",
        title:'menu.PersonaleLabel',
        icon: "far fa-user",
        capacita: ["menu-persone"]
      },
      //...GetPersoneMenus(),
      {
        module: "Clienti",
        capacita: ["menu-clienti"],
        path: "/listautenti/aziende/c",
        title: 'menu.clienti',
        icon: "mdi mdi-account-multiple",
      },
      {
        module: "Clienti",
        capacita: ["menu-clienti"],
        path: "/listautenti/aziende/f",
        title: 'Servizio di Provenienza',
        icon: "mdi mdi-account-multiple",
        notruoliOperativi: ['U']

      },
      {
        module: "taskboard",
        path: "dashboard/files",
        title: 'Notifiche',
        icon: "mdi mdi-calendar",
        ruoliOperativi: ['SO', 'AZ', 'SA']

      },
      {
        module: "Listini",
        path: "listino/listini",
        title: 'menu.listini',
        icon: "mdi mdi-calendar"
      },

      /* {
         module: "Documenti",
         path: "progetti/documenti",
         title: 'menu.DocumentiLabel',
         icon: "mdi mdi-file-document",
         capacita: ["menu-documenti"]
       },*/
      /* {
         module: "Prodotti",
         path: "progetti/prodotti",
         title: 'menu.ProdottiLabel',
         icon: "mdi mdi-barcode-scan",
         capacita: ["menu-prodotti"]
       },*/
      {
        path:"progetti/codicisconto/69/lista",
        title: "Beni",
        icon: "mdi mdi-cart",
        class: "has-arrow",
        capacita: ["menu-magazzini", "gestione-prodotti", "menu-furgoni", "gestione-movimentazioni"],
        submenu: [
          {
            path:"progetti/codicisconto/69/lista",
            title: "Beni",
            icon: "mdi mdi-cart",
            capacita: ["gestione-prodotti"]
          },
          {
            path: "magazzino/movimentazioni/magazzini/furgoni",
            title: "Movimentazioni",
            icon: "far fa-copy",
            capacita: ["gestione-movimentazioni"]
          },
          {
            path: "magazzino/list/magazzini",
            title: "Magazzini",
            icon: "far fa-building",
            capacita: ["gestione-magazzini"]
          },
          {
            path: "magazzino/list/furgoni",
            title: "Associazioni",
            icon: "fas fa-building",
            capacita: ["menu-sbsacaso"]
          },
        ]
      },
      {
        module: "Stampe",
        path: "stampe/templates",
        title: "menu.StampeLabel",
        icon: "mdi mdi-printer",
        class: "has-arrow",
        capacita: ["menu-stampa","menu-blocchi"],
        submenu: [
          {
            path: "stampe/templates",
            title: "Templates",
            capacita: ["gestione-stampa"]
          },
          {
            path: "stampe/marker",
            title: "Marker",
            capacita: ["menu-stampa"]
          },
          {
            path:"/blocchi/blocchi/list",
            title: "Blocchi",
            capacita: ["menu-blocchi"]
          }
        ]
      },
      {
        module: "Settings",
        path: "settings/settings",
        title: "menu.SettingsLabel",
        icon: "mdi-settings",
        capacita: ["menu-settings"]
      },
      {
        module: "Settings",
        path: "settings/smtp",
        title: "menu.smtp",
        icon: "mdi-settings",
        capacita: ["menu-settings"]
      },
      {
        module: "Admin",
        path: "listautenti/roles",
        title: "Ruoli",
        icon: "mdi mdi-lock-open-outline",
        capacita: ["menu-ruoli"]
      },
      {
        notruoliOperativi: ["CA","AC"],
        module: "Ecommerce",
        title: 'menu.EcommerceLabel',
        icon: 'mdi mdi-cart',
        class: 'has-arrow',
        submenu: [
          {
            path: '/ecom/cat',
            title: 'Products',
            icon: 'mdi mdi-cards-variant',
            class: '',
            label: '',
            labelClass: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/ecom/cart',
            title: 'Cart',
            icon: 'mdi mdi-cart',
            class: '',
            label: '',
            labelClass: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/ecom/orders',
            title: 'Orders',
            icon: 'mdi mdi-chart-pie',
            class: '',
            label: '',
            labelClass: '',
            extralink: false,
            submenu: []
          }
        ]
      },
      {
        ruoliOperativi:["AC","C","CA"],
        path: 'Cliente/profile',
        title: "Area Riservata",
        icon: 'mdi mdi-cart',
      }
  ],



  }
  base.theme = 'light';
  base.style = 'FortyFix';
  base.sidebarbg = 'skin6';
  base.logoBg = 'skin6'
  base.MainColor = '#3ea26d';
  base.navbarbg = '#FFFFFF';
  base.navbarAccentColor = '#ea582a';
  base.InputLabelColor = '#333333';
  base.InputTextColor = "#4d4d4d";
  base.langSuffix = '_Alima.json';
  base.BreadcrumbType = "MenuBased";
  base = addModule(InterventiAlimaEnv(), base)
  return base;
};



export var environment = Environment();
